import * as orderConstants from '../Constants/orderConstants';

export const createOrderReducer = (state = { order: {} }, action) => {
  switch (action.type) {
    case orderConstants.CREATE_ORDER_START:
      return {
        loading: true,
      };
    case orderConstants.CREATE_ORDER_SUCCESS:
      return {
        order: action.payload,
        success: true,
      };
    case orderConstants.CREATE_ORDER_FAIL:
      return {
        error: action.payload,
      };
    case orderConstants.CREATE_ORDER_RESET:
      return {};

    default:
      return state;
  }
};

export const getOrder = (state = {}, action) => {
  switch (action.type) {
    case orderConstants.GET_ORDER_START:
      return {
        loading: true,
      };
    case orderConstants.GET_ORDER_SUCCESS:
      return {
        order: action.payload,
        success: true,
      };
    case orderConstants.GET_ORDER_FAIL:
      return {
        error: action.payload,
      };

    default:
      return state;
  }
};

export const orderPayReducer = (state = {}, action) => {
  switch (action.type) {
    case orderConstants.ORDER_PAID_START:
      return {
        loading: true,
      };
    case orderConstants.ORDER_PAID_SUCCESS:
      return {
        success: action.payload,
      };
    case orderConstants.ORDER_PAID_FAIL:
      return {
        error: action.payload,
      };
    case orderConstants.ORDER_PAID_RESET:
      return {};
    default:
      return state;
  }
};

export const orderApproveReducer = (state = {}, action) => {
  switch (action.type) {
    case orderConstants.ORDER_APPROVED_START:
      return {
        loading: true,
      };
    case orderConstants.ORDER_APPROVED_SUCCESS:
      return {
        success: true,
      };
    case orderConstants.ORDER_APPROVED_FAIL:
      return {
        error: action.payload,
      };
    case orderConstants.ORDER_APPROVED_RESET:
      return {};
    default:
      return state;
  }
};

export const orderCancelReducer = (state = {}, action) => {
  switch (action.type) {
    case orderConstants.ORDER_CANCELLED_START:
      return {
        loading: true,
      };
    case orderConstants.ORDER_CANCELLED_SUCCESS:
      return {
        success: true,
      };
    case orderConstants.ORDER_CANCELLED_FAIL:
      return {
        error: action.payload,
      };
    case orderConstants.ORDER_CANCELLED_RESET:
      return {};
    default:
      return state;
  }
};

export const orderDeliverReducer = (state = {}, action) => {
  switch (action.type) {
    case orderConstants.ORDER_DILIVERD_START:
      return {
        loading: true,
      };
    case orderConstants.ORDER_DILIVERD_SUCCESS:
      return {
        success: true,
      };
    case orderConstants.ORDER_DILIVERD_FAIL:
      return {
        error: action.payload,
      };
    case orderConstants.ORDER_DELIVER_RESET:
      return {};
    default:
      return state;
  }
};

export const authOrders = (state = { orders: [] }, action) => {
  switch (action.type) {
    case orderConstants.AUTH_ORDER_FETCH_START:
      return {
        loading: true,
      };
    case orderConstants.AUTH_ORDER_FETCH_SUCCESS:
      return {
        success: true,
        orders: action.payload,
        count: action.total,
      };
    case orderConstants.AUTH_ORDER_FETCH_FAIL:
      return {
        error: action.payload,
      };
    default:
      return state;
  }
};

export const listOrders = (state = { orders: [] }, action) => {
  switch (action.type) {
    case orderConstants.ORDERLIST_FETCH_START:
      return {
        loading: true,
      };
    case orderConstants.ORDERLIST_FETCH_SUCCESS:
      return {
        success: true,
        orders: action.payload.results,
        count: action.payload.count,
      };
    case orderConstants.ORDERLIST_FETCH_FAIL:
      return {
        error: action.payload,
      };
    default:
      return state;
  }
};

export const deleteOrder = (state = {}, action) => {
  switch (action.type) {
    case orderConstants.DELETE_ORDER_START:
      return {
        loading: true,
      };
    case orderConstants.DELETE_ORDER_SUCCESS:
      return {
        success: true,
      };
    case orderConstants.DELETE_ORDER_FAIL:
      return {
        error: action.payload,
      };

    case orderConstants.DELETE_ORDER_RESET:
      return {};

    default:
      return state;
  }
};
